module.exports = __webpack_public_path__ + "42fbac18dac64d1f0914bac58236646b.svg";